<template>
  <div>
    <div class="list list-spaced rounded">
      <slot name="before" />

      <div v-if="loading" class="text-center bg-gray-200">
        <Loader />
      </div>

      <template v-for="item in comments">
        <div v-if="comment && comment.uuid === item.uuid" :key="item.uuid" class="px-4">
          <CommentForm v-if="action === 'edit'" :comment="comment" :submit-action="doUpdateComment">
            <button type="button" class="btn btn-ghost ml-2" @click="cancelAction">Cancel</button>
          </CommentForm>
          <CommentDeleteForm
            v-if="action === 'delete'"
            :comment="comment"
            :submit-action="doDeleteComment"
          >
            <template #default="commentDeleteFormProps">
              <button
                type="button"
                :disabled="commentDeleteFormProps.disabled"
                class="btn btn-ghost ml-2"
                @click="cancelAction"
              >
                Cancel
              </button>
            </template>
          </CommentDeleteForm>
        </div>
        <CommentLine
          v-else
          :key="item.uuid"
          :comment="item"
          @edit-comment="editComment"
          @delete-comment="confirmDeleteComment"
        />
      </template>

      <div v-if="!loading && comments.length === 0" class="bg-gray-200 p-6 text-center">
        There are no comments yet. Add your first comment!
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import CommentLine from './CommentLine.vue';
import CommentForm from './CommentForm.vue';
import CommentDeleteForm from './CommentDeleteForm.vue';

export default {
  components: {
    CommentLine,
    CommentForm,
    CommentDeleteForm,
  },

  props: {
    loading: Boolean,

    comments: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/comments', ['comment']),
  },

  destroyed() {
    this.setCurrent(null);
  },

  methods: {
    ...mapActions('ui/comments', {
      updateComment: 'update',
      deleteComment: 'destroy',
    }),
    ...mapMutations('ui/comments', ['setCurrent']),
    editComment(comment) {
      this.action = 'edit';
      this.setCurrent(comment.uuid);
    },
    confirmDeleteComment(comment) {
      this.action = 'delete';
      this.setCurrent(comment.uuid);
    },
    doUpdateComment(formData) {
      return this.updateComment({ commentUuid: this.comment.uuid, formData })
        .then((response) => {
          this.setCurrent(null);

          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
    doDeleteComment(commentUuid) {
      return this.deleteComment({ commentUuid })
        .then((response) => {
          this.$emit('comment-deleted', response.commentUuid);

          this.setCurrent(null);

          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
    cancelAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
